import { useCallback } from 'react'
import { useTransitionController } from './TransitionProvider'
import type { TriggerProps } from './types'

export const Trigger: React.FC<TriggerProps> = ({ children }) => {
  const { trigger } = useTransitionController()

  const handleTransition = useCallback(() => {
    trigger()
  }, [trigger])

  return <>{children(handleTransition)}</>
}
